import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 1.75C12.6904 1.75 13.25 2.30964 13.25 3V17.9822L18.6161 12.6161C19.1043 12.128 19.8957 12.128 20.3839 12.6161C20.872 13.1043 20.872 13.8957 20.3839 14.3839L12.8839 21.8839C12.3957 22.372 11.6043 22.372 11.1161 21.8839L3.61612 14.3839C3.12796 13.8957 3.12796 13.1043 3.61612 12.6161C4.10427 12.128 4.89573 12.128 5.38388 12.6161L10.75 17.9822V3C10.75 2.30964 11.3096 1.75 12 1.75Z"
        fill={colorValue}
      />
    </svg>
  );
};
